<template>
  <div class="tab-pane fade active show" id="real-time-content" role="tabpanel" aria-labelledby="real-time-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">位置</label>
          <select class="form-control" v-model.number="selectEntrance">
            <option value="-1">全部</option>
            <option v-for="(list, index) in entranceList" :key="index" :value="list.id">{{ list.name }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">交通工具型態</label>
          <select class="form-control" v-model.number="selectVehicleType">
            <option value="-1">全部</option>
            <option v-for="(list, index) in vehicleTypeList" :key="index" :value="list.id">{{ list.description }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料查詢時間</label>
          <datetime input-class="form-control" type="date" format="yyyy-MM-dd" :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1" :max-datetime="maxSelectTime" :auto="true" v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryTrafficFlow"
            :disabled="isWaitResult">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV"
            :disabled="isWaitResult">
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">即時</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="realTimeAreaCar" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="8%">#</th>
                    <th scope="col">位置</th>
                    <th scope="col">車種</th>

                    <!-- <th scope="col">聯結車</th> -->
                    <!-- <th scope="col">大客車</th> -->
                    <!-- <th scope="col">小客車</th> -->
                    <!-- <th scope="col">機車</th> -->
                    <th scope="col">轄區內預估人流</th>
                    <th scope="col">進入車輛平均速度(km/h)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in trafficFlowList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.entrance }}</td>
                    <td>{{ item.vehicleType }}</td>
                    <!-- <td>{{ item.T }}</td>
                    <td>{{ item.L }}</td>
                    <td>{{ item.S }}</td>
                    <td>{{ item.M }}</td> -->
                    <td>{{ item.peopleCount }}</td>
                    <td>{{ item.averageSpeed }}</td>

                  </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2">
          <div id="realAreaCarChart">
            <apexchart type="donut" height="200" :options="chartSetting" :series="chartData"></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import ApexchartObject from '../../utils/apexchartObject/searchAreaCar'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      entranceList: CONST.TRAFFIC_ENTRANCE_ENUM,
      vehicleTypeList: CONST.TRAFFIC_VEHICLE_TYPE_ENUM,
      selectEntrance: -1,
      selectVehicleType: -1,
      trafficFlowList: [],
      startTime: moment(moment().clone().startOf("day").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period,
      endTime: moment(moment().clone().startOf("day").format("YYYY-MM-DD hh:mm")).format(), //vue-datetime-24period,
      isWaitResult: false,
      chartData:[0,0,0],
      chartSetting: ApexchartObject.realTimeOption,
      maxSelectTime: Utils.getLastestTime(),

    };
  },
  watch: {

  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    ...mapState('scenicArea', { scenicAreaList: 'allscenicArea' }),

  },
  methods: {
    getTableAreaName(name) {
      if (Utils.isEmptyObject(name))
        return this.searchAreaName

      return name
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },
    async queryCSV() {
      this.isWaitResult = true
      const trafficFlowList = await this.searchTrafficFlow()

      const date = moment(this.startTime).startOf('d').format('YYYY/MM/DD')  
      const csvContent = [['日期', '位置', '車種', '轄區內預估人流', '進入車輛平均速度(km/h)']]
      trafficFlowList.forEach(item => {
        const row = []
        row.push(date)
        row.push(item.entrance)
        row.push(item.vehicleType)
        row.push(item.peopleCount)
        row.push(item.averageSpeed)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_轄區車流_即時.csv`
      exportCSV.genCSVFile(csvContent, fileName)

      this.isWaitResult = false
    },

    async queryTrafficFlow() {
      this.isWaitResult = true
      this.trafficFlowList = await this.searchTrafficFlow()
      // this.queryChartData(this.trafficFlowList)

      this.setChartData(this.trafficFlowList)
      this.updateTable()

      this.isWaitResult = false
    },

    async searchTrafficFlow() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return []
      }

      if (moment(this.endTime).diff(moment(this.startTime)) < 0) {
        alert('結束時間不可以小於開始時間')
        return []
      }

      const st = moment(this.startTime).startOf('d').valueOf()
      const et = moment(this.startTime).endOf('d').valueOf()

      const condition = {
        startTime: st,
        endTime: et,
        roadEntranceId: this.selectEntrance,
        vehicleType: this.selectVehicleType
      }

      await this.$store.dispatch('trafficFlow/GetDailyTrafficFlowData', condition)
      const dataList = this.$store.getters['trafficFlow/getTrafficFlow']
      const trafficFlowList = this.handlePeopleCount(dataList)
      return trafficFlowList
    },

    handlePeopleCount(dataList) {
      
      // 計算推估人流
      const withoutExit = dataList.filter(d => d.driveDirection === CONST.VD_DETECTION_ID_AREA_CAR.IN) //只要入口
      // const withoutMoto = withoutExit.filter(d => d.vehicleType !== CONST.VD_VEHICLE_TYPE_ID.M) // 不要機車
   
      
      const result = []
      const total = {
        entrance: '統計',

        vehicleType: '',
        peopleCount: 0,
        averageSpeed: 0,
      }
      withoutExit.forEach(e => {
        const data = this.setCarValue(e)
        // const data = e;

        const internalCarTypeEnumList = this.$store.getters['passengerEstimateSetting/getInternalEstimateWeight']
        const holidayMap = this.$store.getters['holidaySetting/getHolidayMap']
        const date = moment(this.startTime).startOf('day').format().split('+')[0]


        switch(data.vehicleType){
          //根據國定假日估算預估人流
          case data.vehicleType === CONST.VD_VEHICLE_TYPE_ID_AREA_CAR.M:
          data.peopleCount = holidayMap.get(date) ? 
          data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.MOTO).holidayWeight
          :data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.MOTO).weight
          break;
          
          case data.vehicleType === CONST.VD_VEHICLE_TYPE_ID_AREA_CAR.S:
          data.peopleCount = holidayMap.get(date) ? 
          data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.CAR).holidayWeight
          : data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.CAR).weight
          break;

          case data.vehicleType === CONST.VD_VEHICLE_TYPE_ID_AREA_CAR.L:
          data.peopleCount = holidayMap.get(date) ? 
          data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.BUS).holidayWeight
          :data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.BUS).weight
          break;

          case data.vehicleType === CONST.VD_VEHICLE_TYPE_ID_AREA_CAR.T:
          data.peopleCount = holidayMap.get(date) ? 
          data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.TRUCK).holidayWeight
          :data.totalCount * internalCarTypeEnumList.find(t => t.enumType === CONST.CAR_TYPE.TRUCK).weight
          break;
        }
        
        data.peopleCount = Math.round(data.peopleCount);

        data.vehicleType = this.getVehicleType(data);
        
        total.peopleCount = total.peopleCount + data.peopleCount;
        total.averageSpeed = total.averageSpeed + data.averageSpeed;
        
        result.push(data)
      })
      total.averageSpeed = Math.round((total.averageSpeed/withoutExit.length)*10)/10;
    
      result.push(total)

      return result
    },

    setCarValue(entrance) {
      // console.log("entrance",entrance)
      const data = {

        entrance: '',
        vehicleType: '',

        peopleCount: 0,
        averageSpeed: 0,
        roadEntranceId: 0
      }

      data.averageSpeed = Math.round(entrance.averageSpeed);
      data.roadEntranceId = entrance.roadEntranceId ;
      data.peopleCount = entrance.totalCount;
      data.vehicleType = entrance.vehicleType;


 
      
      // const TcarData = entrance.find(item => item.vehicleType === CONST.VD_VEHICLE_TYPE_ID.T)
      // const LcarData = entrance.find(item => item.vehicleType === CONST.VD_VEHICLE_TYPE_ID.L)
      // const ScarData = entrance.find(item => item.vehicleType === CONST.VD_VEHICLE_TYPE_ID.S)
      // const McarData = entrance.find(item => item.vehicleType === CONST.VD_VEHICLE_TYPE_ID.M)
      
      data.entrance = this.getEntrance(entrance);
      // console.log("data.vehicleType",data.vehicleType)
     
      // console.log("data",data);
      return data

    },

    // queryChartData(data){
    //   //處理資料分別有北口、中口與南口
    //   console.log("data",data)

 
    // },

    setChartData(list) {
      const dataList = list.slice(0, -1); //移除最後一個統計元素，產生新陣列
      // console.log("dataListlist",dataList)
      let countsByEntrance = {
          '北口': 0,
          '中口': 0,
          '南口': 0
      };

      dataList.forEach(item => {
       // 若該項目的入口匹配，則累加peopleCount
          if (item.entrance in countsByEntrance) {
          countsByEntrance[item.entrance] += Number(item.peopleCount);
          } 
      });
      
      let peopleCount = Object.values(countsByEntrance);
      // 若資料皆為0，則餅圖顯示三等均分樣式
      const allZeros =  peopleCount.every(value => value === 0);
      if(allZeros){
        peopleCount = [20,20,20];
        this.chartSetting.dataLabels.formatter = function (val) {
          return "0";
        };

        this.chartSetting.tooltip.y.formatter = function (val) {
          return "0";
        };

        this.chartSetting.plotOptions.pie.donut.labels.total.formatter = function (w) {
          return "0";
        };
        this.chartData = peopleCount;

      }else{       
        this.chartSetting.tooltip.y.formatter = function (val) {
          return val;
        };
        this.chartSetting.dataLabels.formatter =  function (val) {
          //四捨五入制小數點第二位
          return Math.round(val * 10) / 10 + "%";   
        }
        this.chartSetting.plotOptions.pie.donut.labels.total.formatter = function (w) {
          return w.globals.seriesTotals.reduce((a, b) => {
            return a + b;
          }, 0);
        };
        this.chartData = peopleCount;
      }

      let chartSetting = {...this.chartSetting};
   
      const labels = Object.keys(countsByEntrance);

      chartSetting.labels = labels;
      this.chartSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    getEntrance(item) {
      const target = CONST.TRAFFIC_ENTRANCE_ENUM.find(e => e.id == item.roadEntranceId)
      return target.description
    },

    getVehicleType(item) {
      const target = CONST.TRAFFIC_VEHICLE_TYPE_ENUM.find(e => e.id === item.vehicleType)
      return target.description
    },

    
    initTable: function () {
      this.table = $("#realTimeAreaCar").DataTable({
        aoColumns: [
          ...new Array($("#realTimeAreaCar th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: '/json/dataTableZHTW.json'
        },
        "pageLength": 25,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy()
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
